import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1764.09785,1355.41151 L1920,1511.31366 L1556.92661,1874.38704 L363.073389,1874.38704 L0,1511.31366 L155.902148,1355.41151 L454.365453,1653.87481 L1465.63455,1653.87481 L1764.09785,1355.41151 Z M1070.3333,-7.10542736e-15 L1070.3333,949.966693 L1320.83519,699.354542 L1476.73734,855.25669 L957.761801,1374.23223 L438.786264,855.25669 L594.688412,699.354542 L849.710807,954.376938 L849.710807,-7.10542736e-15 L1070.3333,-7.10542736e-15 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDownloadSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconDownloadSolid, _Component);

  var _super = _createSuper(IconDownloadSolid);

  function IconDownloadSolid() {
    _classCallCheck(this, IconDownloadSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconDownloadSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDownload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDownloadSolid.displayName = "IconDownloadSolid";
  return IconDownloadSolid;
}(Component);

IconDownloadSolid.glyphName = 'download';
IconDownloadSolid.variant = 'Solid';
IconDownloadSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDownloadSolid;
export { IconDownloadSolid };